import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiShield, FiZap, FiTarget, FiUsers } = FiIcons;
import SafeIcon from '../common/SafeIcon';

const WhySellersAnonymous = () => {
  const points = [
    {
      icon: FiShield,
      text: "The industry says one thing, your gut says another.",
    },
    {
      icon: FiZap,
      text: "How can you back your intuition and sell the way you want to?",
    },
    {
      icon: FiTarget,
      text: "How do you balance pressure to close with doing the right thing?",
    }
  ];

  return (
    <section className="py-20 bg-slate-50 border-y border-slate-200">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              Why Sellers Anonymous?
            </h2>
            <p className="text-xl text-cyan-700 font-medium">
              Because it's hard to swim against the tide
            </p>
          </motion.div>

          <div className="space-y-6 mb-12">
            {points.map((point, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center space-x-4 bg-white p-6 rounded-xl shadow-sm border border-slate-100"
              >
                <div className="bg-cyan-50 p-3 rounded-lg flex-shrink-0">
                  <SafeIcon icon={point.icon} className="text-cyan-600 text-xl" />
                </div>
                <p className="text-lg text-slate-700 font-medium">{point.text}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="text-center bg-cyan-600 text-white p-8 rounded-2xl shadow-lg"
          >
            <div className="flex items-center justify-center space-x-3 mb-2">
              <SafeIcon icon={FiUsers} className="text-2xl text-cyan-200" />
              <p className="text-2xl md:text-3xl font-bold italic">
                ...by learning from peers that are doing it!
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhySellersAnonymous;